export const isCoordinationNumber = (identificationNumber: string): boolean => {
  if (identificationNumber.length !== 12) {
    return false;
  }

  const day = Number(identificationNumber.slice(6, 8));

  // Coordination numbers have 60 added days
  if (day > 60) {
    return true;
  }

  return false;
};
